/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes, { number, string, bool } from 'prop-types';
import { Row, Col, Table, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  // faBan,
  faChevronUp,
  faChevronDown,
  faHandHoldingBox,
  faImagePolaroid,
} from '@fortawesome/pro-regular-svg-icons';
import { Tooltip } from 'react-tooltip';

/* TODO: Sort import { faSort, faSortUp } from '@fortawesome/pro-solid-svg-icons'; */

function InventoryTableRow({
  name,
  roomName,
  comments,
  groupCount,
  isPickable,
  itemId,
  isDisabled,
  isGroupHeader,
  isGroupExpanded,
  onExpandRow,
  onToggleExpandGroup,
  onAddToPickList,
}) {
  let tooltipText;

  if (isPickable) {
    if (isGroupHeader) {
      tooltipText = 'Add group to pick list';
    } else {
      tooltipText = 'Add item to pick list';
    }
  } else {
    tooltipText = '';
  }

  return (
    <tr
      key={itemId}
      className={isDisabled ? 'disabled' : ''}
      onClick={onExpandRow || (() => {})}
    >
      {/* TODO: Select row
                    <td className="border-0">
                      <Form.Check type="checkbox" disabled={isDisabled} />
                    </td>
                  */}
      <td className="border-0">
        {isGroupHeader ? (
          <FontAwesomeIcon
            onClick={onToggleExpandGroup}
            icon={isGroupExpanded ? faChevronUp : faChevronDown}
            size="lg"
            className="text-primary"
          />
        ) : (
          <FontAwesomeIcon
            icon={faImagePolaroid}
            size="lg"
            className="text-primary"
          />
        )}
      </td>
      <td className="border-0">
        <a
          onClick={(e) => {
            if (isGroupHeader) {
              onToggleExpandGroup(e);
              e.stopPropagation();
            }
          }}
          data-bs-toggle="collapse"
          href="#inventory-list-row-1"
          role="button"
          aria-expanded="false"
          aria-controls="inventory-list-row-1"
        >
          {name}
        </a>
        {groupCount && <span className="ms-2">({groupCount} items)</span>}
      </td>
      <td className="border-0">{roomName}</td>
      <td className="border-0 small">{comments}</td>
      <td className="border-0 actions text-end">
        <a
          className={isPickable ? 'btn btn-link' : 'default-pointer'}
          href="#"
          // className="btn btn-link"
          onClick={onAddToPickList}
        >
          <FontAwesomeIcon
            icon={faHandHoldingBox}
            size="lg"
            color={isPickable ? '' : 'gray'}
            style={{ opacity: isPickable ? 1 : 0.5 }}
            data-tooltip-id={isPickable ? 'tooltip' : ''}
            data-tooltip-content={tooltipText}
            data-tooltip-place={isPickable ? 'top' : ''}
          />
        </a>
      </td>
    </tr>
  );
}

function ExpandableInventoryTableRow({
  inventoryItem,
  isPickable,
  isDisabled,
  isExpanded,
  handleExpandedRows,
  handleAddToPickList,
  handleShowImage,
}) {
  return (
    <>
      <InventoryTableRow
        key={inventoryItem.InventoryItemID}
        name={inventoryItem.ItemName}
        roomName={inventoryItem.RoomName}
        comments={inventoryItem.Comments}
        isPickable={isPickable}
        itemId={inventoryItem.InventoryItemID}
        isDisabled={isDisabled}
        onExpandRow={() => handleExpandedRows(inventoryItem.InventoryItemID)}
        onAddToPickList={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (isPickable) {
            handleAddToPickList(inventoryItem);
          }
        }}
      />
      <tr onClick={() => handleExpandedRows(inventoryItem.InventoryItemID)}>
        <td className="p-0" colSpan="6">
          <div
            className={`info py-5 px-3 ${isExpanded ? '' : 'collapse'}`}
            id="inventory-list-row-1"
          >
            <Row>
              <Col md={6} lg={3}>
                <img
                  src={inventoryItem.ili[0].FirstImage}
                  alt=""
                  style={{ cursor: 'zoom-in' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleShowImage(inventoryItem.ili[0].FirstImage);
                  }}
                />
              </Col>
              <Col md={6} lg={3}>
                <div className="h3 fw-normal">{inventoryItem.ItemName}</div>
                <Row>
                  <div className="fw-normal">{inventoryItem.ItemTag}</div>
                </Row>
                {inventoryItem.IsDelivered && (
                  <Badge bg="success">Delivered</Badge>
                )}
              </Col>
              <Col md={6} lg={3}>
                <Row>
                  <Col sm={6}>
                    <div className="fw-bold">Shipment</div>
                    {inventoryItem.ShipmentNumber}
                  </Col>
                  <Col sm={6}>
                    <div className="fw-bold">Room</div>
                    {inventoryItem.RoomName}
                  </Col>
                </Row>
              </Col>
              <Col md={6} lg={3}>
                <div className="fw-bold">Comments</div>
                {inventoryItem.Comments || 'None'}
              </Col>
            </Row>
          </div>
        </td>
      </tr>
    </>
  );
}

export function InventoryTable(props) {
  const [expandedGroups, setExpandedGroups] = useState([]);

  const {
    currentPageInventoryItems,
    handleExpandedRows,
    handleAddToPickList,
    handleShowImage,
    isItemInDraftPickList,
    expandedRows,
  } = props;

  return (
    <div className="inventory-list">
      <Table responsive hover>
        <thead>
          <tr>
            {/* TODO: Checkbox column header <th width="4%" /> */}
            <th />
            <th>
              Item Name {/* TODO: Sort <FontAwesomeIcon icon={faSortUp} /> */}
            </th>
            <th>Room {/* TODO: Sort <FontAwesomeIcon icon={faSort} /> */}</th>
            <th>Comments</th>
            <th className="text-end">Actions</th>
          </tr>
        </thead>
        {currentPageInventoryItems.map((inventoryGroup) => {
          const isGroup = inventoryGroup.length > 1;

          if (isGroup) {
            const pickableItemsInGroup = inventoryGroup.filter(
              (groupItem) =>
                !groupItem.PickListID &&
                !isItemInDraftPickList(groupItem) &&
                !groupItem.IsDelivered
            );

            const isGroupPickable = !!pickableItemsInGroup.length;

            const isGroupExpanded = expandedGroups.includes(
              inventoryGroup[0].GroupID
            );

            return (
              <>
                <tbody
                  className={isGroupExpanded ? 'inventory-group-active' : ''}
                >
                  <InventoryTableRow
                    isGroupHeader
                    isPickable={isGroupPickable}
                    isGroupExpanded={isGroupExpanded}
                    groupCount={inventoryGroup.length}
                    name={inventoryGroup[0].GroupName}
                    roomName={inventoryGroup[0].RoomName}
                    itemId={inventoryGroup[0].InventoryItemID}
                    onAddToPickList={(e) => {
                      inventoryGroup.forEach((groupItem) => {
                        handleAddToPickList(groupItem);
                      });
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onToggleExpandGroup={(e) => {
                      e.preventDefault();
                      if (isGroupExpanded) {
                        setExpandedGroups(
                          expandedGroups.filter(
                            (group) => group !== inventoryGroup[0].GroupID
                          )
                        );
                      } else {
                        setExpandedGroups([
                          inventoryGroup[0].GroupID,
                          ...expandedGroups,
                        ]);
                      }
                    }}
                  />
                </tbody>
                <tbody
                  className={`
                    inventory-group
                    ${isGroupExpanded ? '' : 'collapse'}
                  `}
                >
                  {inventoryGroup.map((item) => {
                    const isPickable =
                      !item.PickListID &&
                      !isItemInDraftPickList(item) &&
                      !item.IsDelivered;

                    const isDisabled = item.LocationTypeID === 100;
                    return (
                      <ExpandableInventoryTableRow
                        key={item.InventoryItemID}
                        inventoryItem={item}
                        isPickable={isPickable}
                        isDisabled={isDisabled}
                        handleAddToPickList={handleAddToPickList}
                        handleExpandedRows={handleExpandedRows}
                        handleShowImage={handleShowImage}
                        isExpanded={expandedRows.includes(item.InventoryItemID)}
                      />
                    );
                  })}
                </tbody>
              </>
            );
          }
          return (
            <tbody>
              {inventoryGroup.map((item) => {
                const isPickable =
                  !item.PickListID &&
                  !isItemInDraftPickList(item) &&
                  !item.IsDelivered;

                const isDisabled = item.LocationTypeID === 100;
                return (
                  <ExpandableInventoryTableRow
                    key={item.InventoryItemID}
                    inventoryItem={item}
                    isPickable={isPickable}
                    isDisabled={isDisabled}
                    isExpanded={expandedRows.includes(item.InventoryItemID)}
                    handleShowImage={handleShowImage}
                    handleAddToPickList={handleAddToPickList}
                    handleExpandedRows={handleExpandedRows}
                  />
                );
              })}
            </tbody>
          );

          /*
          return (
            <tbody>
              {inventoryGroup.map((inventoryItem, index) => {
                const isPickable =
                  !inventoryItem.PickListID &&
                  !isItemInDraftPickList(inventoryItem) &&
                  !inventoryItem.IsDelivered;
                const isDisabled = inventoryItem.LocationTypeID === 100;
                return (
                  <>
                    <InventoryTableRow
                      key={inventoryItem.InventoryItemID}
                      name={inventoryItem.ItemName}
                      roomName={inventoryItem.RoomName}
                      comments={inventoryItem.Comments}
                      isPickable={isPickable}
                      itemId={inventoryItem.InventoryItemID}
                      isDisabled={isDisabled}
                      onExpandRow={() => handleExpandedRows(index)}
                      onAddToPickList={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (isPickable) {
                          handleAddToPickList(inventoryItem);
                        }
                      }}
                    />
                    <tr onClick={() => handleExpandedRows(index)}>
                      <td className="p-0" colSpan="6">
                        <div
                          className={`info py-5 px-3 ${
                            expandedRows.includes(index) ? '' : 'collapse'
                          }`}
                          id="inventory-list-row-1"
                        >
                          <Row>
                            <Col md={6} lg={3}>
                              <img
                                src={inventoryItem.ili[0].FirstImage}
                                alt=""
                              />
                            </Col>
                            <Col md={6} lg={3}>
                              <div className="h3 fw-normal">
                                {inventoryItem.ItemName}
                              </div>
                              <Row>
                                <div className="fw-normal">
                                  {inventoryItem.ItemTag}
                                </div>
                              </Row>
                              {inventoryItem.IsDelivered && (
                                <Badge bg="success">Delivered</Badge>
                              )}
                            </Col>
                            <Col md={6} lg={3}>
                              <Row>
                                <Col sm={6}>
                                  <div className="fw-bold">Shipment</div>
                                  {inventoryItem.ShipmentNumber}
                                </Col>
                                <Col sm={6}>
                                  <div className="fw-bold">Room</div>
                                  {inventoryItem.RoomName}
                                </Col>
                              </Row>
                            </Col>
                            <Col md={6} lg={3}>
                              <div className="fw-bold">Comments</div>
                              {inventoryItem.Comments || 'None'}
                            </Col>
                          </Row>
                        </div>
                      </td>
                    </tr>
                  </>
                );
              })}
            </tbody>
            ) */
        })}
      </Table>
      <Tooltip id="tooltip" />
    </div>
  );
}

InventoryTable.defaultProps = {
  currentPageInventoryItems: [],
  expandedRows: [],
};

InventoryTable.propTypes = {
  currentPageInventoryItems: PropTypes.arrayOf(
    PropTypes.shape({
      IsDelivered: bool,
      ShipmentNumner: number,
      InventoryItemID: string,
      ItemTag: string,
      LotID: string,
      Comments: string,
      StorageItemID: number,
      RoomID: string,
      RoomName: string,
      RoomComments: string,
      LocationID: string,
      LocaitonName: string,
      IsLocLocked: bool,
      Percentage: number,
      TotalItemInLocation: number,
      LocationTypeID: number,
      IsHighValue: bool,
      Value: number,
      Customer_ID: number,
      IsItemActive: bool,
      IsVoided: bool,
      Cube: number,
      InventoriedByID: number,
      BingoedByID: number,
      PreppedByID: number,
      LoadedByID: number,
      Height: number,
      Length: number,
      Width: number,
      ili: PropTypes.arrayOf(
        PropTypes.shape({
          LotName: string,
          IsLodLocked: bool,
          HasStorageItemID: number,
          DispLocID: string,
          Warehouse: string,
          InventoriedByName: string,
          BingoedByName: string,
          PreppedByName: string,
          LoadedByName: string,
          ImageCount: number,
          FirstImage: string,
        })
      ),
    })
  ),
  handleExpandedRows: PropTypes.func.isRequired,
  handleAddToPickList: PropTypes.func.isRequired,
  handleShowImage: PropTypes.func.isRequired,
  isItemInDraftPickList: PropTypes.func.isRequired,
  expandedRows: PropTypes.arrayOf(PropTypes.number),
};

InventoryTableRow.defaultProps = {
  comments: '',
  groupCount: null,
  onExpandRow: () => {},
  onToggleExpandGroup: () => {},
  isGroupHeader: false,
  isGroupExpanded: false,
};

InventoryTableRow.propTypes = {
  name: PropTypes.string.isRequired,
  roomName: PropTypes.string.isRequired,
  comments: PropTypes.string,
  groupCount: PropTypes.number,
  isPickable: PropTypes.bool.isRequired,
  itemId: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isGroupHeader: PropTypes.bool,
  isGroupExpanded: PropTypes.bool,
  onExpandRow: PropTypes.func,
  onToggleExpandGroup: PropTypes.func,
  onAddToPickList: PropTypes.func.isRequired,
};

ExpandableInventoryTableRow.propTypes = {
  inventoryItem: PropTypes.object.isRequired,
  isPickable: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  handleAddToPickList: PropTypes.func.isRequired,
  handleExpandedRows: PropTypes.func.isRequired,
  handleShowImage: PropTypes.func.isRequired,
};
